export default "__VITE_ASSET__YHxuXMXJ__"